"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8898,3683],{

/***/ 93683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DownloadProgramForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Forms/index.js + 26 modules
var Forms = __webpack_require__(91212);
// EXTERNAL MODULE: ./src/components/Toaster/index.js + 4 modules
var Toaster = __webpack_require__(19232);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/helpers/countries.js + 1 modules
var countries = __webpack_require__(20890);
;// CONCATENATED MODULE: ./src/domain/DownloadProgram/downloadProgramFormValidationSchema.js


/* harmony default export */ var downloadProgramFormValidationSchema = (es/* object */.Ry().shape({
    firstname: es/* string */.Z_().required("Este campo es requerido").matches(/^[a-zA-Z0-9À-ú ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    lastname: es/* string */.Z_().required("Este campo es requerido").matches(/^[a-zA-Z0-9À-ú ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    email: es/* string */.Z_().email("Escriba una direcci\xf3n de correo v\xe1lida").required("Este campo es requerido"),
    mobilephone: es/* string */.Z_().required("Este campo es requerido").matches(/^(?=.*[0-9])[+()0-9 ]+$/i, "Solo se permiten n\xfameros de tel\xe9fonos v\xe1lidos"),
    city: es/* string */.Z_().required("Este campo es requerido").matches(/^[a-zA-Z0-9À-ú ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    country: es/* string */.Z_().required("Debe seleccionar un pa\xeds").oneOf((0,countries/* countryCodes */.n)(), "Solo se permite un c\xf3digo de dos letras v\xe1lido"),
    website: es/* string */.Z_().notRequired()
}));

;// CONCATENATED MODULE: ./src/domain/DownloadProgram/DownloadProgramForm.js





var defaultProps = {
    onSuccess: function() {
        return null;
    },
    onError: function() {
        return (0,Toaster/* notifyError */.cB)("\n    Ha ocurrido un error cuando intentamos registrar tu solicitud.\n    Por favor int\xe9ntalo nuevamente.\n  ");
    }
};
var propTypes = {
    formUrl: (prop_types_default()).string.isRequired,
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};
function DownloadProgramForm(param) {
    var formUrl = param.formUrl, onSuccess = param.onSuccess, onError = param.onError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* default */.ZP, {
        initialValues: {
            firstname: "",
            lastname: "",
            email: "",
            mobilephone: "",
            city: "",
            country: "",
            website: ""
        },
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
            if (values.website === "") {
                (0,Forms/* submitForm */.R2)(formUrl, values, {
                    setSubmitting: setSubmitting,
                    onSuccess: function onSuccess1() {
                        resetForm();
                        onSuccess();
                    },
                    onError: function onError1(errors) {
                        onError();
                    }
                });
            }
        },
        validationSchema: downloadProgramFormValidationSchema,
        validateOnMount: true,
        children: function(param) {
            var handleChange = param.handleChange, handleBlur = param.handleBlur, isSubmitting = param.isSubmitting, errors = param.errors, touched = param.touched, values = param.values, isValid = param.isValid, setFieldValue = param.setFieldValue, validateForm = param.validateForm;
            var countryHasError = touched.country && errors.country !== undefined;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full min-h-full space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 space-y-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full grid grid-cols-1 lg:grid-cols-2 gap-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                            htmlFor: "firstname",
                                            label: "Nombres",
                                            error: errors.firstname,
                                            touched: touched.firstname,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                                id: "firstname",
                                                name: "firstname",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.firstname,
                                                disabled: isSubmitting,
                                                error: errors.firstname,
                                                touched: touched.firstname,
                                                light: false,
                                                required: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                            htmlFor: "lastname",
                                            label: "Apellidos",
                                            error: errors.lastname,
                                            touched: touched.lastname,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                                id: "lastname",
                                                name: "lastname",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.lastname,
                                                disabled: isSubmitting,
                                                error: errors.lastname,
                                                touched: touched.lastname,
                                                light: false,
                                                required: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                            htmlFor: "email",
                                            label: "Correo electr\xf3nico",
                                            error: errors.email,
                                            touched: touched.email,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* EmailFieldControl */.MG, {
                                                id: "email",
                                                name: "email",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.email,
                                                disabled: isSubmitting,
                                                error: errors.email,
                                                touched: touched.email,
                                                light: false,
                                                required: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                            htmlFor: "mobilephone",
                                            label: "N\xfamero de tel\xe9fono m\xf3vil",
                                            error: errors.mobilephone,
                                            touched: touched.mobilephone,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                                id: "mobilephone",
                                                name: "mobilephone",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.mobilephone,
                                                disabled: isSubmitting,
                                                error: errors.mobilephone,
                                                touched: touched.mobilephone,
                                                light: false,
                                                required: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                            htmlFor: "city",
                                            label: "Ciudad",
                                            error: errors.city,
                                            touched: touched.city,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* TextFieldControl */.p, {
                                                id: "city",
                                                name: "city",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.city,
                                                disabled: isSubmitting,
                                                error: errors.city,
                                                touched: touched.city,
                                                light: false,
                                                required: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormGroup */.cw, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormControl */.NI, {
                                            htmlFor: "country",
                                            label: "Pa\xeds/regi\xf3n",
                                            error: errors.country,
                                            touched: touched.country,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* CountryFieldControl */.n8, {
                                                id: "country",
                                                name: "country",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                setFieldValue: setFieldValue,
                                                validateForm: validateForm,
                                                value: values.country,
                                                disabled: isSubmitting,
                                                error: errors.country,
                                                hasError: countryHasError,
                                                light: false,
                                                required: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "h",
                                autoComplete: "off",
                                type: "text",
                                id: "website",
                                name: "website",
                                placeholder: "Sitio web",
                                onChange: handleChange,
                                value: values.website
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormActions */.iN, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* FormSubmit */.Ow, {
                                    label: "Descargar programa",
                                    submitting: isSubmitting,
                                    disabled: isValid === false || values.website !== ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col space-y-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-xs leading-5 text-gray-700",
                            children: [
                                "Estamos comprometidos con su privacidad. AIBES utiliza la informaci\xf3n que nos proporciona para contactarlo sobre nuestro contenido, productos y servicios relevantes. Puede darse de baja de estas comunicaciones en cualquier momento. Para obtener m\xe1s informaci\xf3n, consulte nuestra\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "font-medium underline",
                                    href: "https://www.aibes.org/legal/privacidad/",
                                    children: "Pol\xedtica de privacidad"
                                }),
                                "."
                            ]
                        })
                    })
                ]
            });
        }
    });
};
DownloadProgramForm.defaultProps = defaultProps;
DownloadProgramForm.propTypes = propTypes;


/***/ }),

/***/ 48898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DownloadProgramModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/Portal/index.js

var Portal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2565).then(__webpack_require__.bind(__webpack_require__, 2565));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2565)
            ];
        }
    },
    ssr: false
});
/* harmony default export */ var components_Portal = (Portal);

// EXTERNAL MODULE: ./src/components/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(95888);
;// CONCATENATED MODULE: ./src/hooks/useScrollBlock.js

var safeDocument = typeof document !== "undefined" ? document : {};
/**
 * Usage:
 *
 * const [blockScroll, allowScroll] = useScrollBlock();
 */ var useScrollBlock = function() {
    var scrollBlocked = (0,react.useRef)();
    var html = safeDocument.documentElement;
    var body = safeDocument.body;
    var blockScroll = function() {
        if (!body || !body.style || scrollBlocked.current) {
            return;
        }
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        var documentWidth = html.clientWidth;
        var width = Math.abs(window.innerWidth - documentWidth);
        var calculatedValue = window.getComputedStyle(body)["paddingRight"];
        body.style["overflow"] = "hidden";
        // trick: We adjust negative marginRight and positive paddingRight to sticky-top elements to keep showing fullwidth
        body.style["marginRight"] = "".concat(Number.parseFloat(calculatedValue) - width, "px");
        body.style["paddingRight"] = "".concat(Number.parseFloat(calculatedValue) + width, "px");
        scrollBlocked.current = true;
    };
    var allowScroll = function() {
        if (!body || !body.style || !scrollBlocked.current) {
            return;
        }
        body.style["overflow"] = "";
        body.style["marginRight"] = "";
        body.style["paddingRight"] = "";
        scrollBlocked.current = false;
    };
    return [
        blockScroll,
        allowScroll
    ];
};
/* harmony default export */ var hooks_useScrollBlock = (useScrollBlock);

// EXTERNAL MODULE: ./src/domain/DownloadProgram/DownloadProgramForm.js + 1 modules
var DownloadProgramForm = __webpack_require__(93683);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/domain/DownloadProgram/DownloadProgramNow.js


var defaultProps = {};
var propTypes = {
    programUrl: (prop_types_default()).string.isRequired,
    trainingName: (prop_types_default()).string.isRequired
};
function DownloadProgramNow(param) {
    var programUrl = param.programUrl, trainingName = param.trainingName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center text-center p-10 lg:py-20 space-y-8 max-w-screen-md mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xl lg:text-2xl font-semibold tracking-tight",
                children: "Tu programa oficial del entrenamiento ".concat(trainingName, " est\xe1 listo para ser descargado.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "inline-flex items-center space-x-2 bg-green-500 hover:bg-green-600 text-white px-8 py-4 leading-4 text-lg lg:text-xl rounded-full cursor-pointer focus:ring-4 focus:ring-green-600 focus:ring-opacity-10 focus:bg-green-600 focus:outline-none",
                    href: programUrl,
                    download: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-6 w-6",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2,
                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-semibold",
                            children: "Descargar ahora"
                        })
                    ]
                })
            })
        ]
    });
};
DownloadProgramNow.defaultProps = defaultProps;
DownloadProgramNow.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
;// CONCATENATED MODULE: ./src/domain/DownloadProgram/DownloadProgramTestimonial.js




var DownloadProgramTestimonial_defaultProps = {
    testimonial: null
};
var DownloadProgramTestimonial_propTypes = {
    modalDescription: (prop_types_default()).string.isRequired,
    modalTitle: (prop_types_default()).string.isRequired,
    testimonial: prop_types_default().shape({
        title: (prop_types_default()).string,
        info: prop_types_default().shape({
            company: (prop_types_default()).string.isRequired,
            position: (prop_types_default()).string.isRequired,
            testimonial: (prop_types_default()).string.isRequired
        }).isRequired,
        featuredImage: prop_types_default().shape({
            node: prop_types_default().shape({
                sizes: (prop_types_default()).string,
                sourceUrl: (prop_types_default()).string,
                srcSet: (prop_types_default()).string
            })
        })
    })
};
function DownloadProgramTestimonial(param) {
    var modalDescription = param.modalDescription, modalTitle = param.modalTitle, testimonial = param.testimonial;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col p-6 lg:p-8 xl:p-10 space-y-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("space-y-3 flex-1", testimonial && "lg:space-y-4", !testimonial && "lg:space-y-6 flex flex-col justify-center lg:px-10"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (0,clsx_m/* default */.Z)("text-2xl lg:text-3xl font-semibold lg:font-bold tracking-tight ", testimonial && "leading-8", !testimonial && "leading-10"),
                        children: modalTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-gray-500 text-base",
                        children: modalDescription
                    })
                ]
            }),
            testimonial && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-semibold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "45",
                                height: "36",
                                className: "mb-5 fill-current text-green-200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M13.415.001C6.07 5.185.887 13.681.887 23.041c0 7.632 4.608 12.096 9.936 12.096 5.04 0 8.784-4.032 8.784-8.784 0-4.752-3.312-8.208-7.632-8.208-.864 0-2.016.144-2.304.288.72-4.896 5.328-10.656 9.936-13.536L13.415.001zm24.768 0c-7.2 5.184-12.384 13.68-12.384 23.04 0 7.632 4.608 12.096 9.936 12.096 4.896 0 8.784-4.032 8.784-8.784 0-4.752-3.456-8.208-7.776-8.208-.864 0-1.872.144-2.16.288.72-4.896 5.184-10.656 9.792-13.536L38.183.001z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                dangerouslySetInnerHTML: {
                                    __html: testimonial.info.testimonial
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-x-4 font-medium text-gray-500 flex items-center w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: testimonial.featuredImage.node.sourceUrl,
                                alt: testimonial.title,
                                className: "w-10 h-10 rounded-full bg-gray-100",
                                width: 120,
                                height: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                className: "text-sm leading-5 font-medium text-gray-900",
                                children: [
                                    testimonial.title,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-normal text-gray-500 text-xs",
                                        children: "".concat(testimonial.info.position, " en ").concat(testimonial.info.company)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
DownloadProgramTestimonial.defaultProps = DownloadProgramTestimonial_defaultProps;
DownloadProgramTestimonial.propTypes = DownloadProgramTestimonial_propTypes;

// EXTERNAL MODULE: ./src/domain/DownloadProgram/DownloadProgramContext.js
var DownloadProgramContext = __webpack_require__(29971);
;// CONCATENATED MODULE: ./src/domain/DownloadProgram/DownloadProgramModal.js










function DownloadProgramModal() {
    var ref = (0,react.useState)(false), isAbleToDownloadProgram = ref[0], setAbleDownloadProgram = ref[1];
    var ref1 = (0,DownloadProgramContext/* useDownloadProgram */.GM)(), portalId = ref1.portalId, formId = ref1.formUrl, programUrl = ref1.programUrl, trainingName = ref1.trainingName, showDownloadProgramModal = ref1.showDownloadProgramModal, modalDescription = ref1.modalDescription, modalTitle = ref1.modalTitle, testimonial = ref1.testimonial, onHideModal = ref1.onHideModal;
    var onDownloadProgramSuccess = (0,react.useCallback)(function() {
        return setAbleDownloadProgram(true);
    }, []);
    var ref2 = (0,_sliced_to_array/* default */.Z)(hooks_useScrollBlock(), 2), blockScroll = ref2[0], allowScroll = ref2[1];
    (0,react.useEffect)(function() {
        if (showDownloadProgramModal) {
            blockScroll();
            return function() {
                return allowScroll();
            };
        }
    }, [
        showDownloadProgramModal,
        blockScroll,
        allowScroll
    ]);
    if (showDownloadProgramModal === false) {
        return null;
    }
    var formUrl = "".concat(portalId, "/").concat(formId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Portal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "fixed inset-0 z-50",
            tabIndex: "-1",
            role: "dialog",
            "aria-labelledby": "Descargar programa de entrenamiento",
            "aria-modal": "true",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pointer-events-none absolute inset-0 z-0 bg-gray-900 opacity-90",
                    style: {
                        backdropFilter: "blur(20px) saturate(120%)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute z-20 inset-0 flex items-center justify-center overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative bg-white shadow-xl lg:shadow-2xl w-full xl:max-w-screen-xl lg:mx-6 lg:my-10 lg:h-full overflow-hidden max-h-full max-w-full flex",
                        role: "document",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                tooltip: "Cerrar",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "absolute right-0 top-0 m-4 w-10 h-10 flex items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 hover:bg-white hover:shadow focus:bg-white focus:ring-green-200 text-gray-400 hover:text-gray-800 focus:text-gray-700",
                                    onClick: onHideModal,
                                    type: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-5 w-5",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                })
                            }),
                            isAbleToDownloadProgram && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "min-h-full overflow-y-auto max-h-full w-full flex flex-col justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadProgramNow, {
                                    programUrl: programUrl,
                                    trainingName: trainingName
                                })
                            }),
                            !isAbleToDownloadProgram && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-1 min-h-full md:grid-cols-2 lg:grid-cols-12 max-h-full overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 lg:col-span-5 hidden md:flex overflow-y-auto max-h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadProgramTestimonial, {
                                            modalDescription: modalDescription,
                                            modalTitle: modalTitle,
                                            testimonial: testimonial
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 lg:col-span-7 flex lg:rounded-r-lg xl:rounded-r-xl pt-16 lg:pt-4 max-h-full overflow-hidden bg-white md:bg-gray-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full flex h-full lg:items-center overflow-y-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "p-6 lg:py-10 lg:px-10 bg-gray-100",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadProgramForm["default"], {
                                                    formUrl: formUrl,
                                                    onSuccess: onDownloadProgramSuccess
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ })

}]);